import { ArrowUpDown } from "lucide-react"
import {Button} from "../../../components/UiComponents/button"
import {Campus, SortDirection, SortParameter} from "../../../api/client"
import {ColumnDef} from "@tanstack/react-table";
import {ProcessedStudentsForAdvisor} from "../../../api/client";
import { DateTime } from "luxon";
import { formatCampus } from "../../../helpers/stringHelpers";


const toggleDirection = (currentDirection: SortDirection | null): SortDirection => {
  if (currentDirection === null || currentDirection === undefined) {
    return SortDirection.Ascending;
  } else if (currentDirection === SortDirection.Ascending) {
    return SortDirection.Descending;
  } else {
    return SortDirection.Ascending;
  }
};

export const columnsProcessed = (
  setDirectionForJoinedQueue : (direction:SortDirection|null)=>void,
  setDirectionForProcessed : (direction:SortDirection|null)=>void,
  setParameters : (parameters:SortParameter|null)=>void, 
): ColumnDef<ProcessedStudentsForAdvisor>[] =>
    [
      {
        accessorKey: "fullName",
        header: () => (
            "Name"
        ),
      },
      {
        accessorKey: "uIdStudent",
        header: () => (
          <Button variant="ghost">USFID</Button>
        ),
      },
      {
        accessorKey: "joinedQueueAt",
        header: ({ column }) => (
          <Button
            variant="ghost"
            onClick={() => {
              setParameters(SortParameter.JoinedQueue);
              setDirectionForJoinedQueue((prevDirection: SortDirection | null): SortDirection | null => {
                return toggleDirection(prevDirection);
              });
            }}
            abbr={column.getIsSorted() === "asc" ? "Click to sort in descending order" : "Click to sort in ascending order"}
          >
            Queued At
            <ArrowUpDown className="ml-2 h-4 w-4" />
          </Button>
        ),
        cell: ({ row }) => {
          const joinedQueueAt = row.original.joinedQueueAt;
          return <span>{joinedQueueAt ? joinedQueueAt.toLocaleString(DateTime.DATETIME_MED) : "N/A"}</span>;
        },
      },
      

      {
        accessorKey: "checkInSince",
        header: ({ column }) => (
          <Button
            variant="ghost"
            onClick={() => {
              setParameters(SortParameter.ProcessedTime);
              setDirectionForProcessed((prevDirection: SortDirection | null): SortDirection | null => {
                return toggleDirection(prevDirection);
              });
            }}
            abbr={column.getIsSorted() === "asc" ? "Click to sort in descending order" : "Click to sort in ascending order"}
          >
            Processed At
            <ArrowUpDown className="ml-2 w-4 h-4" />
          </Button>
        ),
        cell: ({ row }) => {
          const checkInSince = row.original.checkInSince;
          return <span>{checkInSince ? checkInSince.toLocaleString(DateTime.DATETIME_MED) : 'N/A'}</span>;
        },
      },

      {
        accessorKey: "advisorFullName",
        header: () => (
          <Button variant="ghost">Advisor To See</Button> // Question: Why is this a button if it doesn't do anything when clicked?
        ),
        cell: ({ row }) => {
          const advisorName = row.original.advisorFullName;
          return <span>{advisorName}</span>;
        },
      },
    ]


